export const PUT_TAKING_SURVEY = 'PUT_TAKING_SURVEY';
